export default "__VITE_ASSET__16556094__"